import React from "react";

const ServiceLoading = () => {
  return (
    <div className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,0.68fr)_minmax(300px,0.32fr)]">
      <div className="animate-pulse">
        <div className="mb-8 h-80 rounded-md bg-brand-cloud"></div>
        <div className="h-56 rounded-md bg-brand-cloud"></div>
      </div>
      <div className="animate-pulse">
        <div className="mb-6 h-48 rounded-md bg-brand-cloud"></div>
        <div className="h-40 rounded-md bg-brand-cloud"></div>
      </div>
    </div>
  );
};

export default ServiceLoading;
